import { Fragment, ReactElement } from 'react';
import RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-civil-union-non-resident/detail';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CivilUnionDetailAnscNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';

const RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusShared
        items={CivilUnionDetailAnscNotificationsNonResidentSubscriptionCrumbs()}
        scope={IdAmbito.Iscrizioni}
      />
    </Fragment>
  );
};

RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage.displayName =
  'Research CivilUnion Detail Notifications Page component';

export default RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage;
